<template>
  <div class="text-sm w-full">
    <span class="block mb-1 text-gray-900 tracking-wide text-sm font-semibold" v-if="label">
      {{ label }}
      <span v-if="required" class="text-coral-500">*</span>
    </span>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped></style>
